const prefix = "VIN_DECODER";

export const actionTypes = {
    VIN_DECODER_GET_REQUEST: `${prefix}_GET_REQUEST`,
    VIN_DECODER_GET_SUCCESS: `${prefix}_GET_SUCCESS`,
    VIN_DECODER_GET_FAILURE: `${prefix}_GET_FAILURE`
};

export const actionCreators = {
    getRequest: (vin) => ({
        type: actionTypes.VIN_DECODER_GET_REQUEST,
        payload: { vin }
    }),
    getSuccess: (data) => ({
        type: actionTypes.VIN_DECODER_GET_SUCCESS,
        payload: data
    }),
    getFailure: (error) => ({
        type: actionTypes.VIN_DECODER_GET_FAILURE,
        payload: error
    })
};

export default {
    create: actionCreators,
    types: actionTypes
};